const de = {
  title: 'Berechtigung',
  createPermission: 'Berechtigung erstellen',
  model: {
    service: 'Service',
    feature: 'Feature',
    scope: 'Scope',
    result: 'Result',
    roles: 'Rollen'
  },
  deleteConfirm: {
    title: 'Wirklich löschen?',
    message: 'Wollen Sie diese Berechtigung wirklich löschen?'
  },
  alerts: {
    saveFailed: 'Die Berechtigung konnte nicht gespeichert werden.',
    saveSuccess: 'Die Berechtigung wurde erfolgreich gespeichert.',
    deleteFailed: 'Die Berechtigung konnte nicht gelöscht werden.',
    deleteSuccess: 'Die Berechtigung wurde erfolgreich gelöscht.'
  }
};

export default de;
export type PermissionsTranslation = typeof de;
